// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1583": "9ad060f9","1850": "e56fa031","2192": "83ddc331","5189": "84b51783","9415": "e83e4b12",}[chunkId] + ".css"
}